module.exports = __webpack_public_path__ + "empty_state.png?0131e7d24f4934e8e0e05583303b2053";